
export function groupBy(xs: any[], key: any): TGroupByItem[] {
    return xs.reduce(function (rv, x) {
        let v = key instanceof Function ? key(x) : x[key]; let el = rv.find((r) => r && r.key === v); if (el) { el.values.push(x); } else {
            rv.push({
                key: v, values: [x]
            });
        } return rv;
    }, []);
}

export function groupByTyped<TValue>(xs: any[], key: any): TGroupByItemTyped<TValue>[] {
    return xs.reduce(function (rv, x) {
        let v = key instanceof Function ? key(x) : x[key]; let el = rv.find((r) => r && r.key === v); if (el) { el.values.push(x); } else {
            rv.push({
                key: v, values: [x]
            });
        } return rv;
    }, []);
}
export type TGroupByItemTyped<TValue> =  {
    key: any,
    values: TValue[]
}
export type TGroupByItem =  {
    key: any,
    values: any[]
}